module.exports = __webpack_public_path__ + "img/edge_hiver_ski_alpin.0591db16.svg";